/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GoogleCaptchaRequest = {
    properties: {
        token: {
            type: 'string',
            isRequired: true,
        },
        platform: {
            type: 'PlatformEnum',
            isRequired: true,
        },
        isDev: {
            type: 'any-of',
            contains: [{
                type: 'boolean',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
